export default __webpack_public_path__ + "media/src/assets/images/FleetEnableLogo-056752a1c400ab4b53ffd04cb6a3dbc4.svg";